/* eslint-disable @typescript-eslint/no-explicit-any */
function noop() { }
function disableDevTool({ globalKey }) {
    // eslint-disable-next-line no-underscore-dangle
    const DEV_TOOL = window[globalKey];
    const devToolExists = typeof DEV_TOOL === "object";
    if (devToolExists) {
        for (const [key, value] of Object.entries(DEV_TOOL)) {
            DEV_TOOL[key] = typeof value === "function" ? noop : null;
        }
        return true;
    }
    return false;
}
export function disableReactDevTools(disable) {
    if (disable) {
        return disableDevTool({ globalKey: "__REACT_DEVTOOLS_GLOBAL_HOOK__" });
    }
    return disable;
}
//# sourceMappingURL=disableDevTools.js.map